import React from 'react';

import { VoiceAiDashboard } from '@/components/voice-ai-dashboard';
import { useDocumentTitle } from '@/contexts/DocumentTitleContext';

export const VoiceAiDashboardPage: React.FC = () => {
  const { setTitle } = useDocumentTitle();
  React.useEffect(() => {
    setTitle('Voice AI Dashboard');
  }, [setTitle]);

  return <VoiceAiDashboard />;
};
